import React from 'react';
import classnames from 'classnames';

import CollapsibleMenu from 'ui/properties-panel/collapsible-menu';
import { SliderInput } from 'comp/input';

import styles from './compression-panel.scss';

// This determines what the UI should display for elements whose quality has not been set yet.
const DEFAULT_VALUE = 100;

export default class ImageCompressionPanel extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.props.onChange(value);
  }

  render() {
    const { mimeType, value } = this.props;

    if (mimeType !== 'image/jpeg') {
      return null;
    }

    return (
      <CollapsibleMenu title="Image Compression">
        <div className={classnames('form-elm', styles.wrapper)}>
          <SliderInput
            label="Quality"
            min={1}
            max={100}
            step={1}
            value={value || DEFAULT_VALUE}
            onAfterChange={this.handleChange}
          />
          { value && value < 100 &&
            <div className={styles.note}>
              Note: preview the page to see the effect of decreasing quality.
            </div>
          }
        </div>
      </CollapsibleMenu>
    );
  }
}

ImageCompressionPanel.propTypes = {
  mimeType: React.PropTypes.string.isRequired,
  value: React.PropTypes.number,
  onChange: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/properties-panel/images/compression-panel.jsx